
    const html = "<offers profile=profileCtrl.profile authuser=app.user></offers> ";
    angular.module('ng').run(['$templateCache', function($templateCache){
      $templateCache.put('/modules/users/views/profile/profile-view-accommodation.client.view.html', html);
    }]);
    module.exports = '/modules/users/views/profile/profile-view-accommodation.client.view.html';
  